import { render, staticRenderFns } from "./CreacionFormulario.vue?vue&type=template&id=51cd66d9&scoped=true&"
import script from "./CreacionFormulario.vue?vue&type=script&lang=js&"
export * from "./CreacionFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd66d9",
  null
  
)

export default component.exports